<app-header></app-header>
<div class="breadcrumb">
  <div class="container">
    <div class="row">
      <!-- <div class="col-sm-12">
        <span><a class="cursor-link" (click)="goToTheme()">Preview</a> > Education > <strong>Experience</strong></span>
      </div> -->
    </div>
  </div>
</div>
<div class="addExperience">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="editExperience">
          <div class="editExperience__body"
            *ngFor="let exp of experiences | filter : 'index'; index as i; first as isFirst; last as isLast">
            <div class="row">
              <div class="col-sm-12">
                <h5>({{i}}){{exp.job_title}} - {{exp.employer}}
                  <span mwlConfirmationPopover [popoverTitle]="'Delete Experience!'" [popoverMessage]="'Are you sure?'"
                    placement="left" class="editExperience__action float-right" [hidden]="exp.edit"
                    (confirm)="remove(exp)"><span class="icon icon-trash"></span></span>
                  <span class="editExperience__action float-right" (click)="onEditClick(exp)" [hidden]="exp.edit"><span
                      class="icon icon-edit"></span></span>
                </h5>
                <p>{{exp.employer_address}} |
                  <span>{{months[exp.start_month] + ' , ' + exp.start_year}}</span> -
                  <span>{{months[exp.end_month] + ' , ' + exp.end_year}} </span>
                  <span placement="left" class="editExperience__action float-right" *ngIf="!isFirst"
                    (click)="swapIndex(exp, experiences[i-1])"><span class="icon icon-up"></span></span>
                  <span placement="left" class="editExperience__action float-right" *ngIf="!isLast"
                    (click)="swapIndex(exp, experiences[i+1])"><span class="icon icon-down"></span></span>
                </p>
                <div *ngIf="exp.edit">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group input-group">
                        <ng-template #rt let-r="result" let-t="term">
                          <span>
                            {{r.title}}
                          </span>
                        </ng-template>
                        <input type="text" class="form-control form-left" placeholder="Job Title"
                          [(ngModel)]="temp_title" aria-label="Username" aria-describedby="basic-addon1"
                          [ngbTypeahead]="search_rec_title" [inputFormatter]="formatter_rec_title" [focusFirst]="false"
                          [resultTemplate]="rt" (selectItem)="onSelect($event, exp)"
                          (blur)="searchIfNotMatch(temp_title)">
                        <input class="form-control form-right" ngx-google-places-autocomplete [(ngModel)]="exp.employer"
                          placeholder="Company Name" [options]='options'
                          (onAddressChange)="handleAddressChange($event, exp)" />
                      </div>
                      <div class="form-group">
                        <input type="text" class="form-control" name="address" placeholder="Address"
                          [(ngModel)]="exp.employer_address" required>
                      </div>
                      <div class="form-group input-group">
                        <select class="form-control select form-left" [(ngModel)]="exp.start_month">
                          <option [ngValue]="0">January</option>
                          <option [ngValue]="1">February</option>
                          <option [ngValue]="2">March</option>
                          <option [ngValue]="3">April</option>
                          <option [ngValue]="4">May</option>
                          <option [ngValue]="5">June</option>
                          <option [ngValue]="6">July</option>
                          <option [ngValue]="7">August</option>
                          <option [ngValue]="8">September</option>
                          <option [ngValue]="9">October</option>
                          <option [ngValue]="10">November</option>
                          <option [ngValue]="11">December</option>
                        </select>
                        <select class="form-control select form-right" [(ngModel)]="exp.start_year">
                          <option [ngValue]="0">-- Start Year --</option>
                          <option [ngValue]="1980">1980</option>
                          <option [ngValue]="1981">1981</option>
                          <option [ngValue]="1982">1982</option>
                          <option [ngValue]="1983">1983</option>
                          <option [ngValue]="1984">1984</option>
                          <option [ngValue]="1985">1985</option>
                          <option [ngValue]="1986">1986</option>
                          <option [ngValue]="1987">1987</option>
                          <option [ngValue]="1988">1988</option>
                          <option [ngValue]="1989">1989</option>
                          <option [ngValue]="1990">1990</option>
                          <option [ngValue]="1991">1991</option>
                          <option [ngValue]="1992">1992</option>
                          <option [ngValue]="1993">1993</option>
                          <option [ngValue]="1994">1994</option>
                          <option [ngValue]="1995">1995</option>
                          <option [ngValue]="1996">1996</option>
                          <option [ngValue]="1997">1997</option>
                          <option [ngValue]="1998">1998</option>
                          <option [ngValue]="1999">1999</option>
                          <option [ngValue]="2000">2000</option>
                          <option [ngValue]="2001">2001</option>
                          <option [ngValue]="2002">2002</option>
                          <option [ngValue]="2003">2003</option>
                          <option [ngValue]="2004">2004</option>
                          <option [ngValue]="2005">2005</option>
                          <option [ngValue]="2006">2006</option>
                          <option [ngValue]="2007">2007</option>
                          <option [ngValue]="2008">2008</option>
                          <option [ngValue]="2009">2009</option>
                          <option [ngValue]="2010">2010</option>
                          <option [ngValue]="2011">2011</option>
                          <option [ngValue]="2012">2012</option>
                          <option [ngValue]="2013">2013</option>
                          <option [ngValue]="2014">2014</option>
                          <option [ngValue]="2015">2015</option>
                          <option [ngValue]="2016">2016</option>
                          <option [ngValue]="2017">2017</option>
                          <option [ngValue]="2018">2018</option>
                          <option [ngValue]="2019">2019</option>
                          <option [ngValue]="2020">2020</option>
                          <option [ngValue]="2021">2021</option>
                          <option [ngValue]="2022">2022</option>
                          <option [ngValue]="2023">2023</option>
                          <option [ngValue]="2024">2024</option>
                          <option [ngValue]="2025">2025</option>
                          <option [ngValue]="2026">2026</option>
                          <option [ngValue]="2027">2027</option>
                          <option [ngValue]="2028">2028</option>
                          <option [ngValue]="2029">2029</option>
                          <option [ngValue]="2030">2030</option>
                          <option [ngValue]="2031">2031</option>
                          <option [ngValue]="2032">2032</option>
                          <option [ngValue]="2033">2033</option>
                          <option [ngValue]="2034">2034</option>
                          <option [ngValue]="2035">2035</option>
                          <option [ngValue]="2036">2036</option>
                          <option [ngValue]="2037">2037</option>
                          <option [ngValue]="2038">2038</option>
                          <option [ngValue]="2039">2039</option>
                          <option [ngValue]="2040">2040</option>
                        </select>
                      </div>
                      <div class="form-group input-group" *ngIf="exp.current_employer==0">
                        <select class="form-control select form-left" [(ngModel)]="exp.end_month">
                          <option [ngValue]="0">January</option>
                          <option [ngValue]="1">February</option>
                          <option [ngValue]="2">March</option>
                          <option [ngValue]="3">April</option>
                          <option [ngValue]="4">May</option>
                          <option [ngValue]="5">June</option>
                          <option [ngValue]="6">July</option>
                          <option [ngValue]="7">August</option>
                          <option [ngValue]="8">September</option>
                          <option [ngValue]="9">October</option>
                          <option [ngValue]="10">November</option>
                          <option [ngValue]="11">December</option>
                        </select>
                        <select class="form-control select form-right" [(ngModel)]="exp.end_year">
                          <option [ngValue]="0">-- End Year --</option>
                          <option [ngValue]="1980">1980</option>
                          <option [ngValue]="1981">1981</option>
                          <option [ngValue]="1982">1982</option>
                          <option [ngValue]="1983">1983</option>
                          <option [ngValue]="1984">1984</option>
                          <option [ngValue]="1985">1985</option>
                          <option [ngValue]="1986">1986</option>
                          <option [ngValue]="1987">1987</option>
                          <option [ngValue]="1988">1988</option>
                          <option [ngValue]="1989">1989</option>
                          <option [ngValue]="1990">1990</option>
                          <option [ngValue]="1991">1991</option>
                          <option [ngValue]="1992">1992</option>
                          <option [ngValue]="1993">1993</option>
                          <option [ngValue]="1994">1994</option>
                          <option [ngValue]="1995">1995</option>
                          <option [ngValue]="1996">1996</option>
                          <option [ngValue]="1997">1997</option>
                          <option [ngValue]="1998">1998</option>
                          <option [ngValue]="1999">1999</option>
                          <option [ngValue]="2000">2000</option>
                          <option [ngValue]="2001">2001</option>
                          <option [ngValue]="2002">2002</option>
                          <option [ngValue]="2003">2003</option>
                          <option [ngValue]="2004">2004</option>
                          <option [ngValue]="2005">2005</option>
                          <option [ngValue]="2006">2006</option>
                          <option [ngValue]="2007">2007</option>
                          <option [ngValue]="2008">2008</option>
                          <option [ngValue]="2009">2009</option>
                          <option [ngValue]="2010">2010</option>
                          <option [ngValue]="2011">2011</option>
                          <option [ngValue]="2012">2012</option>
                          <option [ngValue]="2013">2013</option>
                          <option [ngValue]="2014">2014</option>
                          <option [ngValue]="2015">2015</option>
                          <option [ngValue]="2016">2016</option>
                          <option [ngValue]="2017">2017</option>
                          <option [ngValue]="2018">2018</option>
                          <option [ngValue]="2019">2019</option>
                          <option [ngValue]="2020">2020</option>
                          <option [ngValue]="2021">2021</option>
                          <option [ngValue]="2022">2022</option>
                          <option [ngValue]="2023">2023</option>
                          <option [ngValue]="2024">2024</option>
                          <option [ngValue]="2025">2025</option>
                          <option [ngValue]="2026">2026</option>
                          <option [ngValue]="2027">2027</option>
                          <option [ngValue]="2028">2028</option>
                          <option [ngValue]="2029">2029</option>
                          <option [ngValue]="2030">2030</option>
                          <option [ngValue]="2031">2031</option>
                          <option [ngValue]="2032">2032</option>
                          <option [ngValue]="2033">2033</option>
                          <option [ngValue]="2034">2034</option>
                          <option [ngValue]="2035">2035</option>
                          <option [ngValue]="2036">2036</option>
                          <option [ngValue]="2037">2037</option>
                          <option [ngValue]="2038">2038</option>
                          <option [ngValue]="2039">2039</option>
                          <option [ngValue]="2040">2040</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>
                          <input type="checkbox" class="" [(ngModel)]="exp.current_employer"
                            (change)="exp.current_employer = exp.current_employer?1:0"> I currently work here
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="tinyMCE form-group">
                        <editor [init]="utilService.editorConfig" [(ngModel)]="exp.description"></editor>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="titleBody form-group">
                        <div class="titleAdd">
                          <div class="titleAdd__plus" *ngFor="let desc of descs" (click)="appendDescription(exp, desc)">
                            <div class="titleAdd__text"><span>Add</span></div>
                            <div>
                              <div class="titleAdd__body">{{desc.text}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button class="btn btn-success" (click)="edit(exp)">Save &amp; Close</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="addMore">
      <div class="col-lg-7 col-sm-6">
        <h2>Add Work Experience</h2>
        <div class="form-group input-group">
          <ng-template #rt let-r="result" let-t="term">
            <span>
              {{r.title}}
            </span>
          </ng-template>
          <input type="text" class="form-control form-left" placeholder="Job Title" [(ngModel)]="temp_title"
            aria-label="Username" aria-describedby="basic-addon1" [ngbTypeahead]="search_rec_title"
            [inputFormatter]="formatter_rec_title" [focusFirst]="false" [resultTemplate]="rt"
            (selectItem)="onSelect($event, newExp)" (blur)="searchIfNotMatch(temp_title)">
          <input class="form-control form-right" ngx-google-places-autocomplete placeholder="Company Name"
            [(ngModel)]="newExp.employer" [options]='options' (onAddressChange)="handleAddressChange($event, newExp)" />
        </div>
        <div class="form-group">
          <input type="text" class="form-control" name="address" placeholder="City"
            [(ngModel)]="newExp.employer_address" required>
        </div>
        <div class="form-group input-group">
          <select class="form-control select form-left" [(ngModel)]="newExp.start_month">
            <option [ngValue]="null">-- Start Month --</option>
            <option [ngValue]="0">January</option>
            <option [ngValue]="1">February</option>
            <option [ngValue]="2">March</option>
            <option [ngValue]="3">April</option>
            <option [ngValue]="4">May</option>
            <option [ngValue]="5">June</option>
            <option [ngValue]="6">July</option>
            <option [ngValue]="7">August</option>
            <option [ngValue]="8">September</option>
            <option [ngValue]="9">October</option>
            <option [ngValue]="10">November</option>
            <option [ngValue]="11">December</option>
          </select>
          <select class="form-control select form-right" [(ngModel)]="newExp.start_year">
            <option [ngValue]="null">-- Start Year --</option>
            <option [ngValue]="2040">2040</option>
            <option [ngValue]="2039">2039</option>
            <option [ngValue]="2038">2038</option>
            <option [ngValue]="2037">2037</option>
            <option [ngValue]="2036">2036</option>
            <option [ngValue]="2035">2035</option>
            <option [ngValue]="2034">2034</option>
            <option [ngValue]="2033">2033</option>
            <option [ngValue]="2032">2032</option>
            <option [ngValue]="2031">2031</option>
            <option [ngValue]="2030">2030</option>
            <option [ngValue]="2029">2029</option>
            <option [ngValue]="2028">2028</option>
            <option [ngValue]="2027">2027</option>
            <option [ngValue]="2026">2026</option>
            <option [ngValue]="2025">2025</option>
            <option [ngValue]="2024">2024</option>
            <option [ngValue]="2023">2023</option>
            <option [ngValue]="2022">2022</option>
            <option [ngValue]="2021">2021</option>
            <option [ngValue]="2020">2020</option>
            <option [ngValue]="2019">2019</option>
            <option [ngValue]="2018">2018</option>
            <option [ngValue]="2017">2017</option>
            <option [ngValue]="2016">2016</option>
            <option [ngValue]="2015">2015</option>
            <option [ngValue]="2014">2014</option>
            <option [ngValue]="2013">2013</option>
            <option [ngValue]="2012">2012</option>
            <option [ngValue]="2011">2011</option>
            <option [ngValue]="2010">2010</option>
            <option [ngValue]="2009">2009</option>
            <option [ngValue]="2008">2008</option>
            <option [ngValue]="2007">2007</option>
            <option [ngValue]="2006">2006</option>
            <option [ngValue]="2005">2005</option>
            <option [ngValue]="2004">2004</option>
            <option [ngValue]="2003">2003</option>
            <option [ngValue]="2002">2002</option>
            <option [ngValue]="2001">2001</option>
            <option [ngValue]="2000">2000</option>
            <option [ngValue]="1999">1999</option>
            <option [ngValue]="1998">1998</option>
            <option [ngValue]="1997">1997</option>
            <option [ngValue]="1996">1996</option>
            <option [ngValue]="1995">1995</option>
            <option [ngValue]="1994">1994</option>
            <option [ngValue]="1993">1993</option>
            <option [ngValue]="1992">1992</option>
            <option [ngValue]="1991">1991</option>
            <option [ngValue]="1990">1990</option>
            <option [ngValue]="1989">1989</option>
            <option [ngValue]="1988">1988</option>
            <option [ngValue]="1987">1987</option>
            <option [ngValue]="1986">1986</option>
            <option [ngValue]="1985">1985</option>
            <option [ngValue]="1984">1984</option>
            <option [ngValue]="1983">1983</option>
            <option [ngValue]="1982">1982</option>
            <option [ngValue]="1981">1981</option>
            <option [ngValue]="1980">1980</option>
            <option [ngValue]="1979">1979</option>
            <option [ngValue]="1978">1978</option>
            <option [ngValue]="1977">1977</option>
            <option [ngValue]="1976">1976</option>
            <option [ngValue]="1975">1975</option>
            <option [ngValue]="1974">1974</option>
            <option [ngValue]="1973">1973</option>
            <option [ngValue]="1972">1972</option>
            <option [ngValue]="1971">1971</option>
            <option [ngValue]="1970">1970</option>
          </select>
        </div>
        <div class="form-group input-group" [hidden]="newExp.current_employer==1">
          <select class="form-control select form-left" [(ngModel)]="newExp.end_month">
            <option [ngValue]="null">-- End Month --</option>
            <option [ngValue]="0">January</option>
            <option [ngValue]="1">February</option>
            <option [ngValue]="2">March</option>
            <option [ngValue]="3">April</option>
            <option [ngValue]="4">May</option>
            <option [ngValue]="5">June</option>
            <option [ngValue]="6">July</option>
            <option [ngValue]="7">August</option>
            <option [ngValue]="8">September</option>
            <option [ngValue]="9">October</option>
            <option [ngValue]="10">November</option>
            <option [ngValue]="11">December</option>
          </select>
          <select class="form-control select form-right" [(ngModel)]="newExp.end_year">
            <option [ngValue]="null">-- End Year--</option>
            <option [ngValue]="2040">2040</option>
            <option [ngValue]="2039">2039</option>
            <option [ngValue]="2038">2038</option>
            <option [ngValue]="2037">2037</option>
            <option [ngValue]="2036">2036</option>
            <option [ngValue]="2035">2035</option>
            <option [ngValue]="2034">2034</option>
            <option [ngValue]="2033">2033</option>
            <option [ngValue]="2032">2032</option>
            <option [ngValue]="2031">2031</option>
            <option [ngValue]="2030">2030</option>
            <option [ngValue]="2029">2029</option>
            <option [ngValue]="2028">2028</option>
            <option [ngValue]="2027">2027</option>
            <option [ngValue]="2026">2026</option>
            <option [ngValue]="2025">2025</option>
            <option [ngValue]="2024">2024</option>
            <option [ngValue]="2023">2023</option>
            <option [ngValue]="2022">2022</option>
            <option [ngValue]="2021">2021</option>
            <option [ngValue]="2020">2020</option>
            <option [ngValue]="2019">2019</option>
            <option [ngValue]="2018">2018</option>
            <option [ngValue]="2017">2017</option>
            <option [ngValue]="2016">2016</option>
            <option [ngValue]="2015">2015</option>
            <option [ngValue]="2014">2014</option>
            <option [ngValue]="2013">2013</option>
            <option [ngValue]="2012">2012</option>
            <option [ngValue]="2011">2011</option>
            <option [ngValue]="2010">2010</option>
            <option [ngValue]="2009">2009</option>
            <option [ngValue]="2008">2008</option>
            <option [ngValue]="2007">2007</option>
            <option [ngValue]="2006">2006</option>
            <option [ngValue]="2005">2005</option>
            <option [ngValue]="2004">2004</option>
            <option [ngValue]="2003">2003</option>
            <option [ngValue]="2002">2002</option>
            <option [ngValue]="2001">2001</option>
            <option [ngValue]="2000">2000</option>
            <option [ngValue]="1999">1999</option>
            <option [ngValue]="1998">1998</option>
            <option [ngValue]="1997">1997</option>
            <option [ngValue]="1996">1996</option>
            <option [ngValue]="1995">1995</option>
            <option [ngValue]="1994">1994</option>
            <option [ngValue]="1993">1993</option>
            <option [ngValue]="1992">1992</option>
            <option [ngValue]="1991">1991</option>
            <option [ngValue]="1990">1990</option>
            <option [ngValue]="1989">1989</option>
            <option [ngValue]="1988">1988</option>
            <option [ngValue]="1987">1987</option>
            <option [ngValue]="1986">1986</option>
            <option [ngValue]="1985">1985</option>
            <option [ngValue]="1984">1984</option>
            <option [ngValue]="1983">1983</option>
            <option [ngValue]="1982">1982</option>
            <option [ngValue]="1981">1981</option>
            <option [ngValue]="1980">1980</option>
            <option [ngValue]="1979">1979</option>
            <option [ngValue]="1978">1978</option>
            <option [ngValue]="1977">1977</option>
            <option [ngValue]="1976">1976</option>
            <option [ngValue]="1975">1975</option>
            <option [ngValue]="1974">1974</option>
            <option [ngValue]="1973">1973</option>
            <option [ngValue]="1972">1972</option>
            <option [ngValue]="1971">1971</option>
            <option [ngValue]="1970">1970</option>
          </select>
        </div>
        <div class="form-group">
          <label>
            <input type="checkbox" class="" [(ngModel)]="newExp.current_employer"
              (change)="newExp.current_employer = newExp.current_employer ? 1 :0"> I currently work here
          </label>
        </div>
      </div>
      <div class="col-lg-1"></div>
      <div class="col-lg-3 col-sm-6">
        <div class="addExperience__bg">
          <img src="../../../../assets/images/resume_{{theme_id}}.jpg" class="img-fluid addExperience__img" />
          <div class="addExperience__overlay"></div>
        </div>
      </div>
      <div class="col-lg-1"></div>
      <div class="col-sm-6">
        <div class="tinyMCE form-group">
          <editor [init]="utilService.editorConfig" [(ngModel)]="newExp.description"></editor>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="titleBody">
          <div class="titleAdd">
            <div class="titleAdd__plus" *ngFor="let desc of descs" (click)="appendDescription(newExp, desc)">
              <div class="titleAdd__text"><span>Add</span></div>
              <div>
                <div class="titleAdd__body">{{desc.text}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-12">
        <div class="addExperience__buttons">
          <button class="btn btn-default" routerLink="/resume/edu">Back</button>
          <button class="btn btn-default" (click)="next()">Skip</button>
          <button class="btn btn-primary" (click)="add()" *ngIf="addMore">Save &amp; Next</button>
          <button class="btn btn-primary" (click)="addMore=true" [hidden]="addMore">Add Another</button>
        </div>
      </div>
      <!-- <div class="col-sm-6 col-8 text-right">
        <div class="addExperience__buttons">
          <button class="btn btn-default" (click)="next()">Skip</button>
          <button class="btn btn-primary" (click)="add()" *ngIf="addMore">Save &amp; Next</button>
          <button class="btn btn-primary" (click)="addMore=true" [hidden]="addMore">Add Another</button>
        </div>
      </div> -->
    </div>
  </div>
</div>
<app-footer></app-footer>